import { createAsyncThunk } from '@reduxjs/toolkit';
import { HARDCODED_ISSUES } from '../data/issues.js';

export const fetchIssues = createAsyncThunk(
  'issues/fetchIssues',
  async (_, { rejectWithValue }) => {
    try {
      return HARDCODED_ISSUES;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
